import { Card } from "@/components/ui/card";
import BookingRow from "@/components/v2/molecules/admin/tabs/AdminBookingsTab/BookingRow";

import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

import { Booking } from "@/hooks/useBookings";

interface BookingsTableProps {
  bookings: Booking[];
  onEdit: (booking: Booking) => void;
  onCopy: (bookingId: string) => void;
  onCancel: (booking: Booking) => void;
  onActivate: (booking: Booking) => void;
  isLoading: boolean;
}

const BookingsTable = ({
  bookings,
  onEdit,
  onCopy,
  onCancel,
  onActivate,
  isLoading,
}: BookingsTableProps) => {
  const tableHeaders = [
    "Huésped",
    "Propiedad",
    "Origen",
    "Llegada",
    "Salida",
    "Noches",
    "Pago Estimado",
    "Hospedaje Realizado",
    "Pago Realizado",
    "Estado",
    "Acciones",
  ];

  return (
    <Card>
      <div className="overflow-auto">
        <Table>
          <TableHeader>
            <TableRow>
              {tableHeaders.map((title) => (
                <TableHead key={title}>{title}</TableHead>
              ))}
            </TableRow>
          </TableHeader>

          <TableBody className="bg-white divide-y divide-gray-200">
            {bookings.map((booking) => (
              <BookingRow
                key={booking.id}
                booking={booking}
                onEdit={onEdit}
                onCopy={onCopy}
                onCancel={onCancel}
                onActivate={onActivate}
                isLoading={isLoading}
              />
            ))}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
};

export default BookingsTable;
